import { Box, Grid, Button, Select,FormControl,InputLabel } from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetUserCountries,
  GetCustomerGroupReferenceData,
  SearchCustomerTrustLevel,
  UpdateCustomerTrustLevel,
  setState,
} from "./functionalAdminSlice";
import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import _ from "lodash";
import Alert from "../../components/ui/Alert";
import muiConfig from '../../assets/MuiConfig.json'

export default function CustomerTrustLevel() {
    
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  const dispatch = useDispatch();
  const apiRef = useGridApiRef();
  const [partnerType, setPartnerType] = useState("");
  const [customerType, setCustomerType] = useState("");
  const [searchText, setSearchText] = useState("");
  const [alert, setAlert] = useState({});
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
  const [updatedValues, setUpdatedValues] = React.useState([]);
  //Only get Initial Values Data
  const functionAdmin = useSelector((state) => state.functionAdmin);
  const {
    isLoading,
    countries,
    selectedCountry,
    selectedCountryID,

    getCustomerGroupRefData,
    customerTrustLevelData,
    clearCustomerTrustLevel,
  } = functionAdmin;

  const loginState = useSelector((store) => store.login);
  const { globalSelectedCountryName,globalSelectedCountryID,} = loginState

  const [rows, setRows] = useState([]);

  const columns = [
    { field: "custID", headerName: "Customer Number", flex: 1 ,  
      renderCell: (params) => (
      <div title={params.row.pName} style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
        {params.value}
      </div>
    )
  },
    {
      field: "customerName",
      headerName: "Customer Name",
      flex: 1,
      renderCell: (params) => (
        <div title={params.row.pName} style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          {params.value}
        </div>
      )
    },
    {
      field: "cgName",
      headerName: "Customer Group",
      flex: 1,
    },
    {
      field: "trustLevel",
      headerName: "Relationship Level",
      flex: 1,
      renderCell: (params) => {
        return <TrustLevel {...params} />;
      },
    },

    {
      field: "stickToQuota",
      headerName: "Automate STQ Decision",
      flex: 1,
      renderCell: (params) => {
        return <StickToQuota {...params} />;
      },
    },
  ];

  useEffect(() => {
    if(globalSelectedCountryName !==null && globalSelectedCountryName !== "" )
    {
    dispatch(setState("selectedCountry", globalSelectedCountryName));
    dispatch(setState("selectedCountryID", globalSelectedCountryID));
    }
    else{
      dispatch(setState("selectedCountry", ""));
    dispatch(setState("selectedCountryID", ""));
    }
    setPartnerType("");
    setCustomerType("");
    dispatch(setState("clearCustomerTrustLevel", false));
  }, []);

  const TrustLevel = (params) => {
    const [trustLevel, setTrustLevel] = useState(params.row.trustLevel);

    const handleStatusChange = (e) => {
      setTrustLevel(e.target.value);
      apiRef.current.updateRows([
        { id: params.id, trustLevel: e.target.value },
      ]);
      setUpdatedValues((prev) => [...prev, params.row]);
    };
    return (
      <Select
        value={trustLevel}
        onChange={handleStatusChange}
        variant="outlined"
        size="small"
        fullWidth
      >
        <MenuItem value={1}>High</MenuItem>
        <MenuItem value={2}>Medium</MenuItem>
        <MenuItem value={3}>Low</MenuItem>
        <MenuItem value={4}>Others</MenuItem>
        <MenuItem value={5}>New</MenuItem>
      </Select>
    );
  };

  const StickToQuota = (params) => {
    console.log(params.row.stickToQuota);
    const [status, setStatus] = useState(params.row.stickToQuota);
    const handleStatusChange = (e) => {
      setStatus(e.target.value);
      apiRef.current.updateRows([
        { id: params.id, stickToQuota: e.target.value },
      ]);
      setUpdatedValues((prev) => [...prev, params.row]);
      // Perform additional actions here, such as updating the row data
    };
    console.log(params);
    return (
      <Select
        value={status}
        onChange={handleStatusChange}
        variant="outlined"
        size="small"
        fullWidth
      >
        <MenuItem value={1}>Enabled</MenuItem>
        <MenuItem value={0}>Disabled</MenuItem>
      </Select>
    );
  };

  useEffect(() => {
    if (customerTrustLevelData.length > 0) {
      setRows(customerTrustLevelData);
    }
    else{
      setRows([]);
    }
  }, [customerTrustLevelData]);
  console.log(rows);
  useEffect(() => {
    //Send data through the function in Slice
    dispatch(GetCustomerGroupReferenceData({ CountryID: selectedCountryID }));
  }, [selectedCountryID]);

  console.log(getCustomerGroupRefData);

  useEffect(() => {
    if (countries.length <= 0) {
      //Send data through the function in Slice
      dispatch(GetUserCountries({ method: "Get" }));
    }
  }, [searchText]);

  const handleSearchText = (e) => {
    const value = e.target.value;
    setSearchText(value);
  };

  const displayAlert = (severityType) => {
    setAlert({
      alertSeverity: "warning",
      alertDisplay: true,
      alertMessage: `Please select the ${severityType}`,
    });

    setTimeout(() => {
      clearAlert();
    }, [3000]);
  };

  const displaySuccess = () => {
    setAlert({
      alertSeverity: "success",
      alertDisplay: true,
      alertMessage: `Saved Successfully!`,
    });

    setTimeout(() => {
      clearAlert();
    }, [3000]);
  };

  const clearAlert = () => {
    setAlert({
      alertSeverity: "",
      alertDisplay: false,
      alertMessage: ``,
    });
  };

  const handleDisplay = () => {
    if (selectedCountry === null || selectedCountry === "") {
      displayAlert("Country");
      return;
    }
    if (partnerType === null || partnerType === "") {
      displayAlert("Partner Type");
      return;
    }
    if (customerType === null || customerType === "") {
      displayAlert("Customer Type");
      return;
    }
    //  /ProductGroup/GetSKUSwitchSearch?CountryID=150&ProductName=ABACAV/LAMIVUD&SKUType=0
    //let partnerType1 = getCustomerGroupRefData?.customerLevels?.find(item => partnerType === item.customerLevel).customerLevelID;
    //let customerTypeCode1 = getCustomerGroupRefData?.customerTypes?.find(item => customerType === item.customerTypeName).customerTypeCode;
    let obj = {
      CountryID: selectedCountryID,
      CustomerName: searchText,
      CustomerCodeType: customerType,
      PartnerType: partnerType,
    };

    dispatch(setState("clearCustomerTrustLevel", true));
    dispatch(SearchCustomerTrustLevel(obj));
  };

  const handleCountryChange = (e) => {
    dispatch(setState("clearCustomerTrustLevel", false));
    setPartnerType("");
    setCustomerType("");
    const name = e.target.value;
    //console.log(countries.find((country) => country.countryName === name));
    const countryID = countries.find(
      (country) => country.countryName === name
    ).countryID;

    dispatch(setState("selectedCountry", name));
    dispatch(setState("selectedCountryID", countryID));
  };

  const handleSave = () => {
    const finalArray = rowSelectionModel.map((id) => {
      let updatedTrustValues = apiRef.current.getRowWithUpdatedValues(id);
      return {
        id: updatedTrustValues.id,
        trustLevel: updatedTrustValues.trustLevel,
        stickToQuota: updatedTrustValues.stickToQuota,
      };
    });

    let obj = {
      CountryID: selectedCountryID,
      CustomerName: searchText,
      CustomerCodeType: customerType,
      PartnerType: partnerType,
    };

    console.log(finalArray);
    dispatch(UpdateCustomerTrustLevel(finalArray)).then(()=> {
      dispatch(SearchCustomerTrustLevel(obj));
    });

    displaySuccess();
  };

  const handlePartnerTypeChange=(e)=>{
    dispatch(setState("clearCustomerTrustLevel", false));
    setPartnerType(e.target.value);
  }
  const handleCustomerTypeChange=(e)=>{
    dispatch(setState("clearCustomerTrustLevel", false));
    setCustomerType(e.target.value);
  }

  return (
    <Box mt={2}>
        <Box>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={isLoading}
          >
            <CircularProgress />
          </Backdrop>
        </Box>
        <Box mt={2}>
          <Grid
            container
            spacing={2}
            alignItems="center"
            wrap="nowrap"
          >
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                variant="outlined"
                label="Country"
                // select={countries.length > 0}
                // value={countries.length > 0 ? selectedCountry.countryName : ""}
                select={countries.length > 0 ? true : false}
                value={selectedCountry}
                onChange={handleCountryChange}
                size="small"
              >
                {countries.length > 0
                  ? countries.map((country) => (
                      <MenuItem key={country.countryID} value={country.countryName}>
                        {country.countryName}
                      </MenuItem>
                    ))
                  : null}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <TextField
                variant="outlined"
                label="Partner Type"
                select={getCustomerGroupRefData?.customerLevels?.length > 0}
                value={partnerType}
                onChange={handlePartnerTypeChange}
                size="small"
              >
                {getCustomerGroupRefData?.customerLevels?.map((item) => (
                  <MenuItem key={item.customerLevelID} value={item.customerLevelID}>
                    {item.customerLevel}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                variant="outlined"
                label="Customer Type"
                select={getCustomerGroupRefData?.customerLevels?.length > 0}
                value={customerType}
                onChange={handleCustomerTypeChange}
                size="small"
              >
                {getCustomerGroupRefData?.customerTypes?.map((type, index) => (
									(type.customerTypeCode === 'P20' || type.customerTypeCode === 'P27' || type.customerTypeCode === 'P31' || type.customerTypeCode === 'P30') ? (
										<MenuItem key={index} value={type.customerTypeCode} disabled={!type.customerTypeCode}>
											{type.customerTypeCode ? `${type.customerTypeCode} | ` : ''}{type.customerTypeName}
										</MenuItem>
									) : null
								))}
								<div style={{ borderBottom: "dashed 1px", paddingBottom: "10px" }}></div>
								{getCustomerGroupRefData?.customerTypes?.map((type, index) => (
									(type.customerTypeCode !== 'P20' && type.customerTypeCode !== 'P27' && type.customerTypeCode !== 'P31' && type.customerTypeCode !== 'P30') ? (
										<MenuItem key={index} value={type.customerTypeCode} disabled={!type.customerTypeCode}>
											{type.customerTypeCode ? `${type.customerTypeCode} | ` : ''}{type.customerTypeName}
										</MenuItem>
									) : null
								))}


              </TextField>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                variant="outlined"
                label="Search"
                value={searchText}
                onChange={handleSearchText}
                size="small"
              ></TextField>
            </Grid>

            <Grid item xs={12} sm={6} md="auto">
              <Box justifyContent="flex-end" display="flex">
                <Button
                  variant="contained"
                  onClick={handleDisplay}
                  size="medium"
                  sx={{
                    bgcolor: "darkred.light",
                    color: "white.main",
                    textTransform: "none",
                    fontWeight: "bold",
                    "&:hover": {
                      bgcolor: "darkred.main",
                      color: "white.main",
                    },
                  }}
                >
                  Search
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      {clearCustomerTrustLevel && (
        <Box
          mt={2}
          sx={{
            width: "100%",
            minHeight: "200px",
          }}
        >
          <DataGridPro
            sx={{
              "& .MuiDataGrid-columnHeaders":{
                backgroundColor:"grey.lighter"
              }
            }}
            style={{ maxHeight: "calc(100vh - 130px)" }}
            apiRef={apiRef}
            rows={rows}
            columns={columns}
            getRowId={(row) => row?.id}
            initialState={{
              pagination: { paginationModel: { pageSize:20, page:0 }}
            }}
            pagination
				    pageSizeOptions={[20, 50, 100, { value: muiConfig.DataGrid_All , label: 'All' }]}	
            onRowSelectionModelChange={(newRowSelectionModel) => {
              setRowSelectionModel(newRowSelectionModel);
            }}
            rowSelectionModel={rowSelectionModel}
            checkboxSelection
            disableRowSelectionOnClick
          />
        </Box>
      )}
      {rowSelectionModel.length > 0 ? (
        <Box mt={3} justifyContent="flex-end" display="flex">
          <Button
            variant="contained"
            onClick={handleSave}
            size="large"
            disabled={!isRestrictedAccess}
            sx={{
              bgcolor: "darkred.light",
              color: "white.main",
              textTransform: "none",
              fontWeight: "bold",
              "&:hover": {
                bgcolor: "darkred.main",
                color: "white.main",
              },
            }}
          >
            Save your changes
          </Button>
        </Box>
      ) : (
        <></>
      )}
      {alert.alertDisplay && (
        <Alert message={alert.alertMessage} severity={alert.alertSeverity} />
      )}
    </Box>
  );
}
